<template>
  <div>
    <v-layout wrap row fill-height>
        <v-flex xs12>
          <h1 class="text-xs-center">{{getDate(date).toDateString()}} {{meet.meet_name1}}</h1>
              <v-data-table :items="scores" hide-headers hide-actions>
              <template v-slot:items="props">
                <td class="text-xs-right">{{props.item.abbr}}</td>
                <td class="text-xs-left">{{props.item.score}}</td>
              </template>
              </v-data-table>
        </v-flex>
        <v-flex xs2 md1 v-for="event in events" :key="event.event_no">
          <v-card height="100%">
            <v-card-title>
              <router-link v-if="event.completed_event===1 && event.ind_rel==='I'" :to="eventLink(event.event_no)">
                #{{event.event_no}} {{event.gender}} {{event.agegroup}} {{event.distance}} {{event.stroke}}
              </router-link>
              <router-link v-else-if="event.completed_event===1 && event.ind_rel==='R'" :to="relayLink(event.event_no)">
                #{{event.event_no}} {{event.gender}} {{event.agegroup}} {{event.distance}} {{event.stroke}}
              </router-link>
              <div v-else>
              #{{event.event_no}} {{event.gender}} {{event.agegroup}} {{event.distance}} {{event.stroke}}
            </div>
            </v-card-title>
          </v-card>
        </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {bus} from '../main';
  export default {
    methods: {
      getDate(val) {
        return new Date(val.substring(0,4), val.substring(4,6)-1, val.substring(6,8));
      },
      eventLink(eventno) {
        return `/eventno?${this.queryString}&eventno=${eventno}`;
      },
      relayLink(eventno) {
        return `/relayno?${this.queryString}&eventno=${eventno}`;
      },
      loadPage() {
        if(this.$route.query.date) {
          this.date = this.$route.query.date;
          this.queryString = `date=${this.date}&team=${this.$route.query.team.join("&team=")}`;
        }
        this.$http.get(`${process.env.VUE_APP_API_URL}/eventtitles?${this.queryString}`)
        .then(function(data) {
          this.events = data.body.events;
          this.scores = data.body.scores;
          this.meet = data.body.meet[0];
        });
      },
      refresh() {
        this.loadPage();
      }
    },
    data: () => ({
      queryString: "",
      date: "",
      meet: "",
      events: [],
      scores: [],
      timer: ""
    }),
    created() {
      this.loadPage();
      bus.$on("refresh", this.refresh);
      this.timer = setInterval(this.refresh,900*1000);
    },
    destroyed() {
      bus.$off("refresh",this.refresh);
      clearInterval(this.timer);
    },
  }
</script>

<style>

</style>
